import React, { Component } from 'react';
import apiInstance from '../apiInstance';

class PaymentMethods extends Component {

    constructor(props) {
        super(props);
        this.state = {
            paymentMethods: [],
        };
    }

    componentDidMount() {
        apiInstance.get('/paymentMethod')
            .then(response => {
                const paymentMethods = response.data.paymentMethods;
                this.setState({
                    paymentMethods: paymentMethods
                });
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    handleDelete = (id) => {
        apiInstance.delete(`/paymentMethod/${id}`)
            .then(response => {
                const updatedPaymentMethods = this.state.paymentMethods.filter(method => method._id !== id);
                this.setState({ paymentMethods: updatedPaymentMethods });
            })
            .catch(error => {
                console.error('Error deleting payment method:', error);
            });
    }
    
    render() {
    
        return (
            <div className="mjwi-settings-container">
                <h3>Payment Methods</h3>
                <div className="mjwi-payment-methods-list">
                    {this.state.paymentMethods.map((method, index) => (
                        <div key={index} className="mjwi-payment-method-item">
                            <p>{method.detail}</p>
                            <p>{method.card.exp_month}/{method.card.exp_year}</p>
                            <i className="fa-solid fa-trash" onClick={(e) => this.handleDelete(method._id)}></i>
                        </div>
                    ))}
                </div>
            </div>

        );
    }
}

export default PaymentMethods;
